var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdgeDotted = function SvgEdgeDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.36 19.698 4.28 20.78l-1.06-1.062 1.08-1.08zm2.205-2.205-1.102 1.103-1.061-1.061 1.102-1.103zm2.205-2.205L8.667 16.39l-1.06-1.06 1.102-1.103zm2.205-2.205-1.102 1.102-1.061-1.06 1.103-1.103zm2.205-2.205-1.102 1.102-1.06-1.06 1.102-1.103zm2.205-2.205-1.102 1.102-1.06-1.06 1.102-1.103zm2.205-2.204L17.488 7.57l-1.06-1.06 1.102-1.103zm2.185-2.185-1.082 1.082-1.06-1.062 1.08-1.08z"
  })));
};
export default SvgEdgeDotted;